import { forwardRef } from 'react'

import type { Props as BasicCreatableSelectInputProps } from '../../Basic/CreatableSelectInput'
import type { ReactNode } from 'react'
import type { GroupBase, Props as SelectProps } from 'react-select'
import type Select from 'react-select/dist/declarations/src/Select'

import BasicCreatableSelectInput from '../../Basic/CreatableSelectInput'
import Wrapper from '../Wrapper'

export interface Props extends Omit<SelectProps, 'isDisabled' | 'isMulti' | 'onChange'> {
  className?: string
  error?: ReactNode
}

const CreatableSelectInput = forwardRef<Select<unknown, boolean, GroupBase<unknown>>, BasicCreatableSelectInputProps>(
  ({ className, error, ...props }: Props, ref) => {
    return (
      <Wrapper className={className} error={error}>
        <BasicCreatableSelectInput {...props} ref={ref} />
      </Wrapper>
    )
  }
)

CreatableSelectInput.displayName = 'CreatableSelectInput'

export default CreatableSelectInput
